var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"containerRef",class:`gradual-blur ${
    _setup.config.target === 'page' ? 'gradual-blur-page' : 'gradual-blur-parent'
  } ${_setup.config.className}`,style:(_setup.containerStyle),on:{"mouseenter":function($event){_vm.hoverIntensity ? _setup.setIsHovered(true) : undefined},"mouseleave":function($event){_vm.hoverIntensity ? _setup.setIsHovered(false) : undefined}}},[_c('div',{staticClass:"gradual-blur-inner",style:({
      position: 'relative',
      width: '100%',
      height: '100%'
    })},_vm._l((_setup.blurDivs),function(div,index){return _c('div',{key:index,style:(div.style)})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }